import { scoreParagraphRecall } from '../paragraphRecall/localDiff';
import { TopicSentence, SentenceScore, TopicDictationResult } from './types';

/**
 * 对单个句子进行评分
 */
export function scoreSentence(sentence: TopicSentence, answer: string): SentenceScore {
  const { coverage, diffRanges } = scoreParagraphRecall({
    reference: sentence.english,
    answer,
    keyUnits: [], // 句子级别不需要关键词
  });

  return {
    index: sentence.index,
    coverage,
    diffRanges,
    english: sentence.english,
    chinese: sentence.chinese,
    answer,
  };
}

/**
 * 对所有句子进行评分并汇总结果
 */
export function scoreAllSentences(
  sentences: TopicSentence[],
  answers: Map<number, string>,
  recallChecks: Set<number>
): TopicDictationResult {
  const sentenceScores = sentences.map((sentence) => {
    const answer = answers.get(sentence.index) || '';
    return scoreSentence(sentence, answer);
  });

  const totalCoverage = sentenceScores.reduce((sum, s) => sum + s.coverage, 0);
  const averageCoverage = sentences.length > 0 ? Math.round(totalCoverage / sentences.length) : 0;

  return {
    averageCoverage,
    sentenceScores,
    recallRatio: sentences.length > 0 ? recallChecks.size / sentences.length : 0,
    evaluatedAt: Date.now(),
  };
}
